import Dialog from "@material-ui/core/Dialog";
import {
    Box,
    Button,
    Grid,
    TextField
} from "@material-ui/core";
import * as React from "react";
import Typography from "@material-ui/core/Typography";
import moment from "jalali-moment";
import {useEffect, useState} from "react";
import {
    convertCurrencyFormat, convertToBirthDate,
    convertToMobileNumber,
    convertToTime
} from "../../utils/numberConvertor";
import {setLoadingStateDispatch, useLoadingDispatcher} from "../../context/LoadingContext";
import {setSnackbarDispatch, SnackbarActionTypes, useSnackbarDispatcher} from "../../context/SnackBarContext";
import {useAuthState} from "../../context/AuthContext";
import {PaymentTransactionService} from "./PaymentTransactionService";
import {ServerErrorHandler} from "../../service/httpClient/ServerErrorHandler";

const PaymentTransactionInfo = ({openModal, handleClose, selectedItemId}) => {

    const loading = useLoadingDispatcher()
    const snackbar = useSnackbarDispatcher()
    const {token, fundID} = useAuthState()

    const service = new PaymentTransactionService(fundID, token, snackbar, loading)

    useEffect(() => {
        if (!openModal) {
            clearFields()
        }
    }, [openModal]);

    function clearFields() {
        setAmount("")
        setFullName("")
        setNationalCode("")
        setPhoneNumber("")
        setDate("")
        setSerial("")
        setGatewaySerial("")
        setStatus("")
        setInstallmentsList([])
        setDepositAccountList([])
        setOtherPaymentList([])

        setPaymentGatewayTitle("")
        setPaymentGatewayType("")
        setPaymentError("")
    }


    useEffect(() => {
        if (selectedItemId >= 0) {
            getPaymentTransactionInfoFromServer()
        }
    }, [selectedItemId])

    function getPaymentTransactionInfoFromServer() {
        loading(setLoadingStateDispatch(true))
        service.getPaymentContent(fundID, selectedItemId)
            .then(response => {

                setAmount(response.amount)
                setFullName(`${response.payerFirstName} ${response.payerLastName}`)
                setPhoneNumber(response.payerPhoneNumber)
                setNationalCode(response.payerNationalCode)
                setDate(`${convertToTime(response.createdAtPersianTime)} ${response.createdAtDate ? moment(response.createdAtDate, 'YYYY-MM-DD').locale('fa').format('YYYY/MM/DD') : ""}`)
                setSerial(response.serial)
                setGatewaySerial(response.gatewaySerial)
                setStatus(response.status === "SUCCESS" ? "پرداخت شده" : "ناموفق")

                setInstallmentsList(response.installmentActions)
                setDepositAccountList(response.depositAccountActions)
                setOtherPaymentList(response.otherPaymentActions)

                setPaymentGatewayTitle(response.paymentGatewayTitle)
                setPaymentGatewayType(response.paymentGatewayType)
                setPaymentError(response.errorMessage ? response.errorMessage : "نامشخص")

                loading(setLoadingStateDispatch(false))
            }).catch(reason => {
            ServerErrorHandler(reason, "خطا در دریافت اطلاعات تراکنش !", snackbar, loading)
        })
    }


    //state-start
    const [amount, setAmount] = useState("")
    const [fullName, setFullName] = useState("");
    const [nationalCode, setNationalCode] = useState("")
    const [phoneNumber, setPhoneNumber] = useState("")
    const [date, setDate] = useState("")

    const [serial, setSerial] = useState("");
    const [gatewaySerial, setGatewaySerial] = useState("");
    const [status, setStatus] = useState("");

    const [installmentsList, setInstallmentsList] = useState([]);
    const [depositAccountList, setDepositAccountList] = useState([]);
    const [otherPaymentList, setOtherPaymentList] = useState([]);

    const [paymentGatewayTitle, setPaymentGatewayTitle] = useState("");
    const [paymentGatewayType, setPaymentGatewayType] = useState("");
    const [paymentError, setPaymentError] = useState("نامشخص");

    //state-end
    return (
        <Dialog fullScreen onClose={handleClose} aria-labelledby="customized-dialog-title" open={openModal}
                id="customized-full-screen-dialog">
            <section className="pageContainer">
                <Box className="transactionHeader">
                    <section className="transactionTitle">
                        <Grid xs={12} sm={12} md={6} lg={6} xl={6}
                              className="d-flex flex-column flex-nowrap justifyContentCenter">
                            <Typography variant={"h6"}>
                                جزئیات تراکنش
                            </Typography>
                        </Grid>
                        <Grid xs={12} sm={12} md={6} lg={6} xl={6} className="loan-details-button-group">
                            <Grid>
                                <Button className="btn-secondary me-2 " onClick={handleClose}>
                                    بازگشت
                                </Button>
                            </Grid>
                        </Grid>
                    </section>
                </Box>
                <Box className="loan-details-main-box">
                    <Box className="w-100" sm={12}>
                        <Grid className='d-flex flex-row flex-wrap flex-grow-1 w-100' sm={12}
                              style={{marginTop: '1rem'}}>
                            <Grid sm={6} md={6} lg={3} xl={3} className='p-2 w-100'>
                                <TextField
                                    value={convertCurrencyFormat(amount)}
                                    className='w-100'
                                    variant="outlined"
                                    disabled={true}
                                    label="مبلغ"/>
                            </Grid>
                            <Grid sm={6} md={6} lg={3} xl={3} className='p-2 w-100'>
                                <TextField
                                    value={fullName}
                                    className='w-100'
                                    variant="outlined"
                                    disabled={true}
                                    label="نام و نام خانوادگی"/>
                            </Grid>
                            <Grid sm={6} md={6} lg={3} xl={3} className='p-2 w-100'>
                                <TextField
                                    value={convertToMobileNumber(phoneNumber)}
                                    className='w-100'
                                    variant="outlined"
                                    disabled={true}
                                    dir={"ltr"}
                                    label="شماره تلفن همراه"/>
                            </Grid>
                            <Grid sm={6} md={6} lg={3} xl={3} className='p-2 w-100'>
                                <TextField
                                    value={nationalCode}
                                    className='w-100'
                                    variant="outlined"
                                    disabled={true}
                                    label="کد ملی"/>
                            </Grid>
                            <Grid sm={6} md={6} lg={3} xl={3} className='p-2 w-100'>
                                <TextField
                                    value={date}
                                    className='w-100'
                                    variant="outlined"
                                    disabled={true}
                                    label="تاریخ"/>
                            </Grid>
                            <Grid sm={6} md={6} lg={3} xl={3} className='p-2 w-100'>
                                <TextField
                                    value={serial}
                                    className='w-100'
                                    variant="outlined"
                                    disabled={true}
                                    label="شناسه پرداخت"/>
                            </Grid>
                            <Grid sm={6} md={6} lg={3} xl={3} className='p-2 w-100'>
                                <TextField
                                    value={gatewaySerial}
                                    className='w-100'
                                    variant="outlined"
                                    disabled={true}
                                    label="شناسه پرداخت زرین پال"/>
                            </Grid>
                            <Grid sm={6} md={6} lg={3} xl={3} className='p-2 w-100'>
                                <TextField
                                    value={status}
                                    className='w-100'
                                    variant="outlined"
                                    disabled={true}
                                    label="وضعیت"/>
                            </Grid>
                            <Grid sm={6} md={6} lg={3} xl={3} className='p-2 w-100'>
                                <TextField
                                    value={paymentGatewayTitle}
                                    className='w-100'
                                    variant="outlined"
                                    disabled={true}
                                    label="نام درگاه پرداخت"/>
                            </Grid>
                            <Grid sm={6} md={6} lg={3} xl={3} className='p-2 w-100'>
                                <TextField
                                    value={paymentGatewayType}
                                    className='w-100'
                                    variant="outlined"
                                    disabled={true}
                                    label="نوع درگاه پرداخت"/>
                            </Grid>
                            <Grid sm={12} className='p-2 w-100'>
                                <TextField
                                    value={paymentError}
                                    className='w-100'
                                    variant="outlined"
                                    disabled={true}
                                    label="پیغام خطا"/>
                            </Grid>
                        </Grid>
                    </Box>
                    <section className={`${depositAccountList.length > 0 ? "d-flex flex-column" : "d-none"}`}>
                        <Box className={"BorderBox mt-3"}>
                            <Box className="d-flex flex-column">
                          <span className="titleOfOBorderBox">
                        واریز ماهیانه
                    </span>
                                <Typography style={{margin: "8px 8px 0 8px"}} variant={"caption"}>
                                    {depositAccountList.length > 0 ? `${depositAccountList.length} تراکنش ثبت شده` : ""}
                                </Typography>

                            </Box>
                        </Box>
                        <Box className="d-flex flex-column">
                            {
                                depositAccountList.map((item, index) => {
                                    return <Box className="cardCustom">
                                        <Grid xs={6} sm={4} md={3} lg={1} xl={1}
                                              className="cardCustomContent p-2 w-100">
                                            <span className="cardCustomTitle">#</span>
                                            <span className="cardCustomDescription">{index + 1}</span>
                                        </Grid>
                                        <Grid xs={6} sm={4} md={3} lg={2} xl={2}
                                              className="cardCustomContent p-2 w-100">
                                            <span className="cardCustomTitle">شماره حساب</span>
                                            <span className="cardCustomDescription">{item.depositAccountNumber}</span>
                                        </Grid>
                                        <Grid xs={6} sm={4} md={3} lg={2} xl={3}
                                              className="cardCustomContent p-2 w-100">
                                            <span className="cardCustomTitle">نام و نام خانوادگی</span>
                                            <span
                                                className="cardCustomDescription">{`${item.ownerFirstName} ${item.ownerLastName}`}</span>
                                        </Grid>
                                        <Grid xs={6} sm={4} md={3} lg={2} xl={2}
                                              className="cardCustomContent p-2 w-100">
                                            <span className="cardCustomTitle">کد ملی</span>
                                            <span
                                                className="cardCustomDescription">{item.ownerNationalCode}</span>
                                        </Grid>
                                        <Grid xs={6} sm={4} md={3} lg={2} xl={2}
                                              className="cardCustomContent p-2 w-100">
                                            <span className="cardCustomTitle">تاریخ</span>
                                            <span
                                                className="cardCustomDescription">{moment(item.date, 'YYYY-MM-DD').locale('fa').format('YYYY/MM/DD')}</span>
                                        </Grid>
                                        <Grid xs={6} sm={4} md={3} lg={2} xl={2}
                                              className="cardCustomContent p-2 w-100">
                                            <span className="cardCustomTitle">مبلغ (ریال)</span>
                                            <span
                                                className="cardCustomDescription">{convertCurrencyFormat(item.amount)}</span>
                                        </Grid>
                                    </Box>

                                })
                            }
                        </Box>
                    </section>
                    <section className={`${installmentsList.length > 0 ? "d-flex flex-column" : "d-none"}`}>
                        <Box className="BorderBox mt-3">
                            <Box className="d-flex flex-column">
                          <span className="titleOfOBorderBox">
                        پرداخت اقساط
                    </span>
                                <Typography style={{margin: "8px 8px 0 8px"}} variant={"caption"}>
                                    {installmentsList.length > 0 ? `${installmentsList.length} تراکنش ثبت شده` : ""}
                                </Typography>

                            </Box>
                        </Box>
                        <Box className="d-flex flex-column">
                            {installmentsList.map((item, index) => {
                                return <Box className="cardCustom">
                                    <Grid xs={6} sm={4} md={3} lg={1} xl={2}
                                          className="cardCustomContent p-2 w-100">
                                        <span className="cardCustomTitle">#</span>
                                        <span className="cardCustomDescription">{index + 1}</span>
                                    </Grid>
                                    <Grid xs={6} sm={4} md={3} lg={2} xl={2}
                                          className="cardCustomContent p-2 w-100">
                                        <span className="cardCustomTitle">شناسه وام</span>
                                        <span className="cardCustomDescription">{item.loanId}</span>
                                    </Grid>
                                    <Grid xs={6} sm={4} md={3} lg={2} xl={2}
                                          className="cardCustomContent p-2 w-100">
                                        <span className="cardCustomTitle">شماره حساب</span>
                                        <span className="cardCustomDescription">{item.depositAccountNumber}</span>
                                    </Grid>
                                    <Grid xs={6} sm={4} md={3} lg={3} xl={3}
                                          className="cardCustomContent p-2 w-100">
                                        <span className="cardCustomTitle">مبلغ وام (ریال)</span>
                                        <span
                                            className="cardCustomDescription">{convertCurrencyFormat(item.loanAmount)}</span>
                                    </Grid>
                                    <Grid xs={6} sm={4} md={3} lg={3} xl={3}
                                          className="cardCustomContent p-2 w-100">
                                        <span className="cardCustomTitle">وام گیرنده</span>
                                        <span
                                            className="cardCustomDescription">{`${item.ownerLoanFirstName} ${item.ownerLoanLastName}`}</span>
                                    </Grid>

                                    <Grid xs={6} sm={4} md={3} lg={3} xl={2}
                                          className="cardCustomContent p-2 w-100">
                                        <span className="cardCustomTitle">شماره قسط</span>
                                        <span
                                            className="cardCustomDescription">{item.installmentNumber}</span>
                                    </Grid>

                                    <Grid xs={6} sm={4} md={3} lg={3} xl={2}
                                          className="cardCustomContent p-2 w-100">
                                        <span className="cardCustomTitle">شماره ملی</span>
                                        <span
                                            className="cardCustomDescription">{item.ownerLoanNationalCode}</span>
                                    </Grid>

                                    <Grid xs={6} sm={4} md={3} lg={3} xl={2}
                                          className="cardCustomContent p-2 w-100">
                                        <span className="cardCustomTitle">سررسید قسط</span>
                                        <span
                                            className="cardCustomDescription">{moment(item.installmentPaymentDate, 'YYYY-MM-DD').locale('fa').format('YYYY/MM/DD')}</span>
                                    </Grid>
                                    <Grid xs={6} sm={4} md={3} lg={3} xl={3}
                                          className="cardCustomContent p-2 w-100">
                                        <span className="cardCustomTitle">مبلغ قابل پرداخت (ریال)</span>
                                        <span
                                            className="cardCustomDescription">{convertCurrencyFormat(item.installmentPayableAmount)}</span>
                                    </Grid>
                                    <Grid xs={6} sm={4} md={3} lg={3} xl={3}
                                          className="cardCustomContent p-2 w-100">
                                        <span className="cardCustomTitle">مبلغ پرداخت شده (ریال)</span>
                                        <span
                                            className="cardCustomDescription">{convertCurrencyFormat(item.amount)}</span>
                                    </Grid>
                                </Box>
                            })}
                        </Box>
                    </section>

                    <section className={`${otherPaymentList.length > 0 ? "d-flex flex-column" : "d-none"}`}>
                        <Box className="BorderBox mt-3">
                            <Box className="d-flex flex-column">
                          <span className="titleOfOBorderBox">
                        بازارچه
                    </span>
                                <Typography style={{margin: "8px 8px 0 8px"}} variant={"caption"}>
                                    {otherPaymentList.length > 0 ? `${otherPaymentList.length} خرید ثبت شده` : ""}
                                </Typography>

                            </Box>
                        </Box>
                        <Box className="d-flex flex-column">
                            {otherPaymentList.map((item, index) => {
                                return <Box className="cardCustom">
                                    <Grid xs={6} sm={4} md={2} lg={2} xl={2}
                                          className="cardCustomContent p-2 w-100">
                                        <span className="cardCustomTitle">#</span>
                                        <span className="cardCustomDescription">{index + 1}</span>
                                    </Grid>
                                    <Grid xs={6} sm={4} md={2} lg={2} xl={2}
                                          className="cardCustomContent p-2 w-100">
                                        <span className="cardCustomTitle">عنوان خرید</span>
                                        <span className="cardCustomDescription">{item.otherPaymentTitle}</span>
                                    </Grid>
                                    <Grid xs={6} sm={4} md={2} lg={2} xl={2}
                                          className="cardCustomContent p-2 w-100">
                                        <span className="cardCustomTitle">مبلغ کل</span>
                                        <span
                                            className="cardCustomDescription">{convertCurrencyFormat(item.amount)}</span>
                                    </Grid>
                                    <Grid xs={6} sm={4} md={2} lg={2} xl={2}
                                          className="cardCustomContent p-2 w-100">
                                        <span className="cardCustomTitle">تاریخ شروع</span>
                                        <span
                                            className="cardCustomDescription">{convertToBirthDate(item.otherPaymentStartDate)}</span>
                                    </Grid>
                                    <Grid xs={6} sm={4} md={2} lg={2} xl={2}
                                          className="cardCustomContent p-2 w-100">
                                        <span className="cardCustomTitle">تاریخ پایان</span>
                                        <span
                                            className="cardCustomDescription">{convertToBirthDate(item.otherPaymentEndDate)}</span>
                                    </Grid>

                                    <Grid xs={6} sm={4} md={2} lg={2} xl={2}
                                          className="cardCustomContent p-2 w-100">
                                        <span className="cardCustomTitle">تاریخ خرید</span>
                                        <span
                                            className="cardCustomDescription">{convertToBirthDate(item.date)}</span>
                                    </Grid>
                                </Box>
                            })}
                        </Box>
                    </section>
                </Box>
            </section>
            {/*<DialogActions>
                <Button className="btn-confirm m-4">
                    بروزرسانی
                </Button>
            </DialogActions>*/}
        </Dialog>
    )
}
export default PaymentTransactionInfo